// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__9WAek","button_all":"styles_button_all__ClpCb","button__icon":"styles_button__icon__XvH6J"};